module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAcUlEQVR4AWOgC2g7/hiO/mMAZNmB0vDv378vP76+//rh/z/iNBy8d+jl60sbTk/bdnM7YQ1///1de3XD93f3L9yaPfX0pL///hG2Yc3BRev2TFm8v3nRrilEOen79y+P3t56/PbOt68f0TQMxngYlAAAU5t7KKTcrZ8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GT.png
// module id = 1155
// module chunks = 0